module.exports = __webpack_public_path__ + "static/media/diktat-38.5fe14b93.mp3";